import {useMediaQuery} from '@s-ui/react-hooks'
import {LayoutMediaQueryFactory} from '@s-ui/react-layout-media-query'

// same as on $breakpoints packages/theme/src/settings/index.scss
const BREAKPOINTS = {
  xs: '480',
  sm: '600',
  md: '768',
  lg: '970',
  xl: '1300',
  xxl: '1680'
}

const LayoutRenderMediaQuery = LayoutMediaQueryFactory(BREAKPOINTS)

LayoutRenderMediaQuery.displayName = 'LayoutRenderMediaQuery'

const MEDIA_QUERY_BREAKPOINTS = {
  xs: `(min-width:${BREAKPOINTS.xs}px)`,
  sm: `(min-width:${BREAKPOINTS.sm}px)`,
  md: `(min-width:${BREAKPOINTS.md}px)`,
  lg: `(min-width:${BREAKPOINTS.lg}px)`,
  xl: `(min-width:${BREAKPOINTS.xl}px)`,
  xxl: `(min-width:${BREAKPOINTS.xxl}px)`
}

export {useMediaQuery, BREAKPOINTS as breakpoints, MEDIA_QUERY_BREAKPOINTS as useMediaQueryBreakpoints}

export default LayoutRenderMediaQuery
